import { Capacitor } from '@capacitor/core';

export const isNative = Capacitor.isNativePlatform();
export const isIOS = Capacitor.getPlatform() === 'ios';
export const isWeb = !isNative;

export function getApiBaseUrl() {
  if (isNative) {
    return 'https://www.euchretable.com/api';
  }
  return process.env.REACT_APP_API_URL || '/api';
}

export function getSocketUrl() {
  if (isNative) {
    return 'https://www.euchretable.com';
  }
  return window.location.port === '3000'
    ? 'http://localhost:3001'
    : window.location.origin;
}
